import React from "react";
import { Route, Switch } from "react-router-dom";
import * as Section from "@repoflow/components/section";
import BlogPostPublicSchema from "@common/schema/blog-post/public";
import * as ListRoute from "./list";
import * as NewRoute from "./new";
import * as PostRoute from "./post";

const LocalProvider = ({ match: { params }, children: Children }) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/post`;
  const basepath = `${parentBasepath}/post`;

  return (
    <Section.Provider
      schema={BlogPostPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          {/* Before `/:postId`, which would otherwise match the literal. */}
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:postId`} component={PostRoute.Content} />
          <Route path={`${basepath}`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Indice} />
          <Route path={`${basepath}/:postId`} component={PostRoute.Indice} />
          <Route path={`${basepath}`} component={ListRoute.Indice} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => null;
